angular.module('omfm').service('Emails', InboxEmailsService);

InboxEmailsService.$inject = ['$resource', 'ServerInterceptor'];

function InboxEmailsService($resource, ServerInterceptor) {
	return $resource('/inbox', {"id": "@id"}, {

		'inboxCounter':{
			'url':'/inbox/inbox_counter',
			'method': 'get',
			'interceptor': ServerInterceptor
		},
		'refreshAccount':{
			'url': "/inbox/refresh_account",
			'method': 'post',
			'interceptor': ServerInterceptor
		},
		'refreshAccountInbox':{
			'url': "/inbox/refresh_account_inbox",
			'method': 'post',
			'interceptor': ServerInterceptor
		},
		'list': {
			'url': "/inbox/list",
			'method': 'get',
			'interceptor': ServerInterceptor
		},
		'checkNewEmails': {
			'url': "/inbox/check_new",
			'method': 'get',
			'interceptor': ServerInterceptor
		},
		'setLabel': {
			'url': "/inbox/set_label",
			'method': 'post',
			'interceptor': ServerInterceptor
		},
		'markAsRead': {
			'url': "/inbox/read",
			'method': 'post',
			'interceptor': ServerInterceptor
		},
		'unsetLabel': {
			'url': "/inbox/unset_label",
			'method': 'post',
			'interceptor': ServerInterceptor
		},
		'open': {
			'url': "/inbox/get/:id",
			'method': 'get',
			'interceptor': ServerInterceptor
		}
	})
}